<template>
    <div>
        <div>
            <button type="button" class="btn btn-primary mb-2" @click="addProduct">Add Product</button>
            <category-product v-for="(product, index) in products" :key="index" :_products="{all_products, products}"
                v-model="products[index]" @remove="remove(index)" @input="updateIndex($event, index)">
            </category-product>
        </div>
        <button type="submit" class="btn btn-primary" @click="updateProducts">Submit</button>
        <button type="button" class="btn btn-default border" @click="cancel">返回</button>
    </div>
</template>
<script>
    import config from "../../../config";
    import CategoryProdut from './CategoryProduct';
    window.config = config;
    export default {
        components: {
            CategoryProdut
        },
        props: ['_category', 'back_url'],
        data() {
            return {
                apis: {
                    loadAvailableProducts: () => {
                        axios.get(config.admin_api.products.index).then(({ data }) => this.all_products = data);
                    },
                    loadCategoryProducts: () => {
                        axios.get(config.admin_api.categories.products(this.category.id)).then(({data}) => this.products = data);
                    },
                    updateCategoryProducts: (products) => {
                        axios.patch(config.admin_api.categories.updateProducts(this.category.id), { products }).then(({data}) => this.products = data);
                    }
                },
                category: this._category,
                all_products: [],
                products: []
            };
        },
        mounted() {
            // load all products on system
            this.apis.loadAvailableProducts();
            this.apis.loadCategoryProducts();
        },
        methods: {
            updateIndex(value = null, key = null) {
                let length = this.products.length;
                let tmp_products = this.products.map((product, key) => { return { key, product } });
                let no_target_set = tmp_products.filter(item => item.key !== key);
                if (value) {
                    value.index = String(Number(value.index) > length ? Number(value.index) % length : Number(value.index));
                    value.index = String(Number(value.index) < 1 ? length : Number(value.index));
                }
                for (let index = 1; index <= length; index++) {
                    let current_index;
                    if (value && String(index) === value.index) current_index = key;
                    else {
                        let min_index = String(Math.min(...no_target_set.map(({ product }) => Number(product.index))));
                        let min_item_index = no_target_set.findIndex(({ product }) => String(product.index) === min_index);
                        if (min_item_index !== -1) {
                            current_index = no_target_set[min_item_index].key;
                            no_target_set.splice(min_item_index, 1);
                        } else {
                            current_index = key;
                        }
                    }
                    this.products[current_index].index = String(index);
                }
            },
            updateProducts() {
                this.products = this.products.filter(product => this.all_products.map(product => product.id).includes(product.product_id));
                this.updateIndex();
                let valid_products = this.products.filter(product => this.all_products.map(product => product.id).includes(product.product_id));
                this.apis.updateCategoryProducts(valid_products);
            },
            addProduct() {
                if (this.products.length < this.all_products.length)
                    this.products.push({
                        category_id: this.category.id,
                        product_id: 0,
                        index: String(this.products.length + 1)
                    });
            },
            cancel() {
                if (typeof Turbolinks !== 'undefined' && Turbolinks.supported) Turbolinks.visit(this.back_url);
                else window.location.href = this.back_url;
            },
            remove(index) {
                this.products.splice(index, 1);
                this.updateIndex();
            }
        }
    };
</script>
<style scoped></style>